import { Box, Select, Chip, FormControl, MenuItem, InputLabel, OutlinedInput } from "@mui/material";
import React from "react";
import * as PropTypes from "prop-types";
import { isFunction } from "../utils";
import { useTranslation } from "react-i18next";
import { CompTooltipIcon } from "./TooltipIcon";

const CompMultiselectDropdown2 = (props) => {
    let { error } = props;
    const {
      rows = [],
      selectedRows = [],
      keyColumn,
      valueColumn,
      valueFunc = (row) => (row?.[valueColumn] ?? row).toString(),
      onSelect,
      disabled = false,
      label = "",
      parentsUnselectable = false,
      ...componentProps
    } = props;
    //NOTE: TEST FUNCTIONALITY WELL BEFORE USING IN OTHER COMPONENTS IN PROD. CURRENTLY ONLY IN USE FOR THE NEW FUNCTIONS MODULE
    const { t } = useTranslation("translation");
    error = error !== undefined && error !== null ? t("errors." + error) : null;

    const handleChange = (event) => {
      const nextIds = event.target.value;
      const prevIds = selectedRows ?? [];

      const added = nextIds.filter((id) => !prevIds.includes(id));
      const removed = prevIds.filter((id) => !nextIds.includes(id));

      let toggledId, isAddAction;
      if (added.length) {
          toggledId = added[0];
          isAddAction = true;
      } else if (removed.length) {
          toggledId = removed[0];
          isAddAction = false;
      } else {
          return;
      }

      const row = rows.find((r) => r[keyColumn] === toggledId);
      if (!row) return;

      const index = rows.indexOf(row);
      const i = prevIds.indexOf(toggledId);

      if (isFunction(onSelect)) {
        onSelect(row, isAddAction, index, i);
      }
    };

    return (
      <FormControl
        className={`comp-multiselect-dropdown-container 
          ${props.className ? "container-" + props.className : ""} 
          ${error ? "error" : ""} 
          ${disabled ? "disabled" : ""}`}
      >
        <InputLabel disabled={disabled} shrink={true}>{label}</InputLabel>

        <Select
          multiple
          disabled={disabled}
          {...componentProps}
          value={selectedRows}
          onChange={handleChange}
          input={
              <OutlinedInput
                  notched
                  label={label}
              />
          }
          renderValue={(selectedIds) => {
            const chips = selectedIds.slice(0, 2).map((id) => {
              const r = rows.find((row) => row[keyColumn] === id);
              if (!r) return null;
              return (
                <Chip
                  className="item"
                  key={id}
                  label={valueFunc(r).trim()}
                  disabled={disabled}
                />
              );
            });

            return (
              <Box sx={{ padding: "0px", display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                {chips}
                {selectedIds.length > 2 && (
                  <Chip label={`+${selectedIds.length - 2} ${t("components.multiselect_dropdown_more")}`} />
                )}
              </Box>
            );
          }}
          disableUnderline
          MenuProps={{
            anchorOrigin: { vertical: "bottom", horizontal: "left" },
            transformOrigin: { vertical: "top", horizontal: "left" },
            PaperProps: { style: { maxHeight: "50%" } },
          }}
          className={"dropdown-select dropdown_custom"}
          sx={{ padding: "0px !important",
            '&:hover .MuiOutlinedInput-notchedOutline': {
              borderColor: '#007FFF',
            },
            "& .MuiOutlinedInput-notchedOutline": {
                borderColor: "#404CE2", //fix in future scss var issues when using in mui sx prop
            },
            ...(disabled && {
                '&:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: '#00000042',
                },
            })
          }}
        >
          <MenuItem disabled value="">
            -- {t("components.select")} --
          </MenuItem>

          {rows.map((row, index) => {
            const isSelected = selectedRows.includes(row[keyColumn]);
            return (
              <MenuItem
                key={`option-${row[keyColumn]}`}
                value={row[keyColumn]}
                className={`option option-${index}`}
                sx={{
                  fontWeight: isSelected ? "bold" : "normal",
                  backgroundColor: isSelected ? "rgba(25, 118, 210, 0.1)" : "transparent",
                  "&.Mui-selected": { backgroundColor: "rgba(25, 118, 210, 0.15) !important" },
                  "&:hover": { backgroundColor: "rgba(25, 118, 210, 0.2)" },
                }}
              >
                {parentsUnselectable && row.disabled ? valueFunc(row) : valueFunc(row)}
                {row.descriptionFi && t("report.current_language") === "FINNISH" && (
                  <CompTooltipIcon ignore={true}>{row.descriptionFi}</CompTooltipIcon>
                )}
                {row.descriptionSv && t("report.current_language") !== "FINNISH" && (
                  <CompTooltipIcon ignore={true}>{row.descriptionSv}</CompTooltipIcon>
                )}
              </MenuItem>
            );
          })}
        </Select>

        <div className={`error-label ${props.className ? "error-" + props.className : ""}`}>
          {error}
        </div>
      </FormControl>
    );
};

CompMultiselectDropdown2.propTypes = {
  label: PropTypes.string,
  rows: PropTypes.array,
  selectedRows: PropTypes.array,
  error: PropTypes.string,
};

export { CompMultiselectDropdown2 };
